import React from 'react';

type StatusChipVariant =
  | 'suggested'
  | 'vetting'
  | 'verified'
  | 'matched'
  | 'active'
  | 'on-hold'
  | 'in-review';

interface StatusChipProps {
  variant: StatusChipVariant;
  label?: string;
}

const VARIANT_STYLES: Record<StatusChipVariant, string> = {
  suggested: 'bg-surface-secondary text-on-surface-secondary',
  vetting: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-500/15 dark:text-yellow-400',
  verified: 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-400',
  matched: 'bg-teal-50 text-teal-900 dark:bg-teal-500/15 dark:text-teal-300',
  active: 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-400',
  'on-hold': 'bg-yellow-50 text-yellow-800 dark:bg-yellow-500/15 dark:text-yellow-400',
  'in-review': 'bg-teal-100 text-teal-800 dark:bg-teal-500/15 dark:text-teal-400',
};

const DEFAULT_LABELS: Record<StatusChipVariant, string> = {
  suggested: 'Suggested',
  vetting: 'Vetting',
  verified: 'Verified',
  matched: 'Matched',
  active: 'Active',
  'on-hold': 'On Hold',
  'in-review': 'In Review',
};

export function StatusChip({ variant, label }: StatusChipProps): React.ReactNode {
  return (
    <span
      className={`inline-flex items-center rounded px-8 py-2 text-[1.1rem] font-medium ${VARIANT_STYLES[variant]}`}
    >
      {label ?? DEFAULT_LABELS[variant]}
    </span>
  );
}
